module.exports = __webpack_public_path__ + "img/role-title-en.0ac8437c.png";